import React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import DevicesList from '#component/shipment/overview/devices-list';

const Transition = React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);

export const DevicesDialog = props => {
  const {
    open,
    account,
    handleClose,
    clickedDevices
  } = props;

  return (
    <Dialog
      TransitionComponent={Transition}
      onClose={handleClose}
      open={open}
      fullScreen
      className="cluster"
    >
      <DevicesList
        account={account}
        devices={clickedDevices}
        closeList={handleClose}
      />
    </Dialog>

  );
};
